export default (originalText = null, columns = {}, withUrl = true) => ({
    originalText,

    columns,

    columnsClass: {
        url: 'bg-gray-800',
    },

    init() {
        this.$nextTick(() => {
            this.$refs.container.style.height = this.$refs.originalText.offsetHeight + 'px';

            new MutationObserver(() => {
                this.$refs.container.style.height = this.$refs.originalText.offsetHeight + 'px';
            }).observe(this.$refs.originalText, {
                attributes: true,
                attributeFilter: ['style'],
            });

            this.$refs.originalText.onscroll = () => {
                this.$refs.container.scrollTop = this.$refs.originalText.scrollTop;
                this.$refs.container.scrollLeft = this.$refs.originalText.scrollLeft;
            };

            if (withUrl) {
                this.columns.url = 'URL';
            }

            this.$watch('originalText', this.blueprint.bind(this));
            this.blueprint();
        });
    },

    blueprint() {
        let formattedText = String(this.originalText);

        if (withUrl) {
            formattedText = formattedText.replace(/\<url\>/gi, '#url#');
        }

        formattedText = this.htmlEscape(formattedText);

        Object.keys(this.columns).map((column) => {
            let text = null;
            let regex = new RegExp(`\\#${column}\\b`, 'i');

            if (column == 'url') {
                regex = new RegExp(`\\#${column}\\#`, 'i');
            }

            while ((text = formattedText.match(regex))) {
                const nextChar = text.input[text.index + text[0].length + 1];
                const addMargin = !['#', '<'].includes(nextChar)
                    ? nextChar == ' '
                        ? '-mr-1'
                        : ''
                    : 'mr-1';

                const tag = this.getColumnTag(column, text[0], addMargin);

                formattedText = formattedText.replace(regex, tag);
            }
        });

        this.$refs.container.innerHTML = formattedText.replace(/(\n|\r|\n|\r\n)/gi, '</br>');
    },

    htmlEscape(str) {
        return str
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');
    },

    getTextSize(text) {
        const element = document.createElement('span');

        element.innerText = text;
        element.style.position = 'absolute';
        element.style.zIndex = '-1';

        this.$el.appendChild(element);
        const size = element.offsetWidth;

        element.remove();
        return size;
    },

    getColumnTag(column, text, addSpace = '') {
        const size = this.getTextSize(text) * 0.87;
        const classes = _.get(this.columnsClass, column, 'bg-blue-400');

        return (
            ' ' +
            `
            <div
                class="text-xs ${classes} inline-block text-center rounded text-white ${addSpace}"
                style="width: ${size}px;"
            >
                ${this.columns[column]}
            </div>
        `
                .replace(/\n|\r/g, ' ')
                .replace(/\s+/g, ' ')
        );
    },
});
